import { EXCHANGE_ACTIONS } from 'redux/actions/exchange';

import { UPDATE_EXCHANGE_DATA } from 'redux/actions/markets';

const initialState = {
  isLoading: true,
  orderBookAsk: [],
  orderBookBid: [],
  orderBookAskMaxVolume: 0,
  orderBookBidMaxVolume: 0,
  tradeHistory: null,
  depthChartData: null,
  tradingPair: {},
  tradingPairStats: {},
  tradingPairSettings: {},
  orderBookSelected: { rate: 0, volume: 0, stop: 0 },
  orderBookTotal: { bidBaseCurrency: 0, bidQuoteCurrency: 0, askBaseCurrency: 0, askQuoteCurrency: 0 },
};

export const exchangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXCHANGE_ACTIONS.CLEAR_EXCHANGE:
      return {
        ...initialState,
        orderBookSelected: { ...initialState.orderBookSelected },
      };
    case EXCHANGE_ACTIONS.UPDATE_DEPTH_CHART:
      return { ...state, depthChartData: action.payload };
    case EXCHANGE_ACTIONS.UPDATE_TRADING_PAIR:
      return { ...state, ...action.payload };
    case EXCHANGE_ACTIONS.UPDATE_ORDER_BOOK:
      return {
        ...state,
        orderBookAsk: action.payload.asks,
        orderBookBid: action.payload.bids,
      };
    case EXCHANGE_ACTIONS.UPDATE_ORDER_BOOK_BIDS:
      return {
        ...state,
        orderBookBid: action.payload.orderBook,
        orderBookBidMaxVolume: action.payload.maxVolume,
      };
    case EXCHANGE_ACTIONS.UPDATE_ORDER_BOOK_ASKS:
      return {
        ...state,
        orderBookAsk: action.payload.orderBook,
        orderBookAskMaxVolume: action.payload.maxVolume,
      };
    case EXCHANGE_ACTIONS.UPDATE_TRADE_HISTORY:
      return { ...state, tradeHistory: action.payload };
    case UPDATE_EXCHANGE_DATA:
      return { ...state, tradingPairStats: action.payload };
    case EXCHANGE_ACTIONS.UPDATE_ORDER_BOOK_SELECTION:
      return {
        ...state,
        orderBookSelected: {
          ...action.payload,
          orderBookSelectedTimestamp: Date.now(),
        },
      };

    case EXCHANGE_ACTIONS.UPDATE_ORDER_BOOK_TOTAL:
      return { ...state, orderBookTotal: action.payload };

    default:
      return state;
  }
};
